<template>
  <div class="outer-container">
    <div class="container">
      <div class="inner-container" :style="{ backgroundColor: bgColor.color }">
        <h2 class="header-font text-center">Course Outline</h2>

        <hr
          :style="{ backgroundColor: bgColor.brColor, height: '1px' }"
          class="paddin"
        />
        <div class="grid" v-for="i in info" :key="i.classNumber">
          <div class="">
            <h2>{{ i.classNumber }}</h2>
            <h3>
              {{ i.classSub }}
            </h3>
          </div>
          <div class="">
            <ul v-for="(j, index) in i.orderList" :key="index">
              <li>
                <h5>
                  {{ index + 1 }}
                  .{{ j }}
                </h5>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Array,
      require: true,
    },
    bgColor: {
      type: Object,
      require: true,
    },
  },
}
</script>

<style scoped>
.paddin {
  padding: 0px 200px;
}
ul {
  list-style: none;
}
ul li h5 {
  padding-top: 12px;
  font: 400 1rem/1.2rem 'Manrope';
}
.outer-container {
  padding: 100px 0;
  background-color: #f8f8f9;
}
hr {
  margin: 55px 0;
}
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-top: 50px;
  grid-gap: 55px;
  padding-bottom: 60px;
  border-bottom: 1px solid white;
}

.grid h5 {
  padding-top: 0;
  font: 700 1rem/1.25rem 'Manrope';
  color: white;
}
.grid h2 {
  font: 700 3.25rem/4rem 'Manrope';
  color: #fbbf05;
}
.grid h3 {
  font: 700 1.5rem/1.75rem 'Manrope';
  color: white;
}
.inner-container {
  max-width: 1300px;
  margin: 0 auto;
  padding: 20px 150px;

  padding-bottom: 80px;
}
.header-font {
  padding-top: 70px;
  font: 800 2.25rem/2.75rem 'Manrope';
  color: white;
  padding-bottom: 50px;
}
ol li {
  font: 400 1rem/1.125rem 'Manrope';
  color: white;
}
ul li {
  font: 400 1rem/1.125rem 'Manrope';
  color: white;
}
@media only screen and (max-width: 600px) {
  hr {
    margin: 15px 0;
  }
  .header-font {
    padding-top: 70px;
    font: 800 2.25rem/2.75rem 'Manrope';
    color: white;
    padding-bottom: 0px;
  }
  .grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 55px;
  }
  .inner-container {
    max-width: 100%;
    margin: 0 auto;
    padding: 20px 20px;
  }
  ol {
    padding-left: 20px;
  }
  ul {
  }
  ol li {
    font: 400 1rem/1.125rem 'Manrope';
    color: white;
  }
  ul li {
    font: 400 1rem/1.125rem 'Manrope';
    color: white;
  }
}
</style>
